import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonsModule } from '@maia/buttons';
import { ModalsModule as MaiaModalsModule } from '@maia/modals';
import { PopUpsModule as MaiaPopUpsModule } from '@maia/pop-ups';
import { NoticeComponent } from './notice/notice.component';
import { FlowModule } from '../flow/flow.module';
import { ContactSlideComponent } from './contact-slide/contact-slide.component';
import { SomethingWentWrongComponent } from './something-went-wrong/something-went-wrong.component';

@NgModule({
  imports: [
    CommonModule,
    MaiaPopUpsModule,
    MaiaModalsModule,
    ButtonsModule,
    FlowModule,

  ],
  declarations: [
    NoticeComponent,
    ContactSlideComponent,
    SomethingWentWrongComponent
  ],
  exports: [
    NoticeComponent,
    ContactSlideComponent,
  ],
  entryComponents: [
    NoticeComponent,
    ContactSlideComponent,
    SomethingWentWrongComponent,
  ]
})
export class ModalsModule { }
